module.exports = __webpack_public_path__ + "img/question.d3d3eee6.svg";